// extracted by mini-css-extract-plugin
module.exports = {"noData":"-no-data-noData-2jadR--"};